
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.544 8.25H2.474A2.485 2.485 0 000 10.724v9.946a2.485 2.485 0 002.474 2.475h14.07A1.46 1.46 0 0018 21.689V9.705a1.43 1.43 0 00-1.456-1.455zm0 13.876H2.474c-.824 0-1.504-.68-1.504-1.504v-9.897c0-.825.68-1.504 1.504-1.504h14.07c.243 0 .485.193.485.485v3.687H13.73c-.873 0-1.6.728-1.6 1.601v1.456c0 .873.727 1.6 1.6 1.6h3.3v3.688c0 .194-.195.388-.486.388zm.486-5.094h-3.3a.642.642 0 01-.63-.631v-1.456c0-.34.29-.63.63-.63h3.3v2.717z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.943 16.498c.437 0 .825-.34.825-.825 0-.485-.34-.825-.825-.825-.485 0-.824.34-.824.825 0 .486.388.825.824.825zm0-.97c.098 0 .146.097.146.145 0 .049-.097.146-.146.146-.048 0-.145-.097-.145-.146 0-.048.048-.145.145-.145z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.953 5.496L9 8.45 6.047 5.496M9 8.04V2.05","stroke":"#fff","stroke-width":"1.432","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    